module.exports = __webpack_public_path__ + "assets/f4719685cd917f938e234a75c55a02e7.png";